import * as React from 'react';
import {Mutation} from 'react-apollo';

import type {
    EmailAutomationStatusStatus as EmailAutomationStatus,
    EmailAutomationStatusCancel as EmailAutomationStatusCancelMutation,
    EmailAutomationStatusCancelVariables as EmailAutomationStatusCancelMutationVariables,
} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../analytics-client';

import EMAIL_AUTOMATION_STATUS_CANCEL from './graphql/mutations/email-automation-status-cancel.graphql';

const CANCELLED_STATUS: EmailAutomationStatus = 'CANCELLED_MANUALLY';

class CancelMutation extends Mutation<
    EmailAutomationStatusCancelMutation,
    EmailAutomationStatusCancelMutationVariables
> {}

type Props = {
    children: (arg1: {
        onCancel: (id: string, currentEmailAutomationStatus?: any) => Promise<any>;
    }) => React.ReactElement;
};

export function CancelEmailAutomation(props: Props) {
    return (
        <CancelMutation
            mutation={EMAIL_AUTOMATION_STATUS_CANCEL}
            onError={() => {
                // this should not be reached :fingers_crossed:

                window.alert('Unable to cancel this sequence. Please contact support');
            }}
        >
            {(emailAutomationStatusCancel) =>
                props.children({
                    onCancel: (id, currentEmailAutomationStatus) => {
                        const optimisticResponse = currentEmailAutomationStatus
                            ? {
                                  __typename: 'Mutation',
                                  emailAutomationStatusCancel: {
                                      __typename: 'EmailAutomationStatusCancelPayload',
                                      emailAutomationStatus: {
                                          ...currentEmailAutomationStatus.node,
                                          status: CANCELLED_STATUS,
                                      },
                                  },
                              }
                            : undefined;

                        return emailAutomationStatusCancel({
                            variables: {
                                input: {
                                    emailAutomationStatus: {
                                        id,
                                    },
                                },
                            },
                            // @ts-expect-error
                            optimisticResponse,
                        }).then(() => {
                            analyticsClient.track(
                                analyticsClient.EVENTS
                                    .TRACK_AUTOMATION_STATUS_MANUALLY_CANCELLED_FROM_LIST
                            );
                        });
                    },
                })
            }
        </CancelMutation>
    );
}
